/**
 * Scroll to top on button click.
 */
export default function() {
  const nav = document.querySelectorAll('.js-inpage-nav, .js-inpage-nav-toc');
  const nav_h = document.querySelector('.js-inpage-nav-heading');
  const toFocus = nav.length > 0 ? nav[0].querySelector('li a') : null;
  
  Array.from(document.querySelectorAll('.js-back-to-top')).forEach(btn => {
    btn.addEventListener('click', e => {
      document.body.dispatchEvent(new Event('back-to-top'));
      if (nav_h) {
        const prevEl = nav_h.previousElementSibling;

        const aboveNavOffset = prevEl ? prevEl.getBoundingClientRect().bottom : nav_h.parentElement().getBoundingClientRect().top;

        const scrollY = aboveNavOffset + window.pageYOffset;
        window.scrollTo(0, scrollY);

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }

      if (toFocus) {
        toFocus.focus();
      }
    });
  });
};
